const dashboard = [
    {
        path: "",
        component: () => import("../components/Index.vue"),
        meta: {
            requireAuth: false,
        },
        children: [
            {
                path: "",
                component: () => import("../components/Dashboard.vue"),
                name: "student.dashboard",
                meta: {
                    requireAuth: false,
                },
            },
            {
                path: "/presence",
                component: () => import("../components/PresenceQrScanner.vue"),
                name: "student.presence",
                meta: {
                    requireAuth: false,
                },
            },
            {
                path: "/schedule",
                component: () => import("../components/Schedule.vue"),
                name: "student.schedule",
                meta: {
                    requireAuth: false,
                },
            },
            {
                path: "/:id",
                component: () => import("../components/Course.vue"),
                name: "student.course",
                meta: {
                    requireAuth: false,
                },
            },
        ],
    },
];
export default dashboard;
